import { UseQueryOptions } from "react-query/types/react/types";

import { httpService } from "utils";
import { DateObject } from "utils/DateObject";
import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";

import { useReactQuery } from "components/RemoteData";

import { IAppointmentActionResponse } from "../types/IAppointmentActionResponse";
import { IAppointmentActionResponseDto } from "../Dtos/IAppointmentActionResponseDto";

export const useGetEditAppointment = (
  tokenId: string,
  options?: UseQueryOptions<IAppointmentActionResponse>
) => {
  const { friendlyUrl } = useGetFriendlyUrl();

  return useReactQuery<IAppointmentActionResponse>(
    getEditAppointmentTokenKey(tokenId),
    () => getEditAppointmentToken(tokenId, friendlyUrl),
    options
  );
};

const getEditAppointmentToken = (
  token: string,
  friendlyUrl: string
): Promise<IAppointmentActionResponse> => {
  return httpService()
    .get<IAppointmentActionResponseDto>(
      `/e-reservation/${friendlyUrl}/appointment/edit/${token}`
    )
    .then((res) => {
      return {
        ...res,
        createDate: DateObject(res.createDate),
        startDate: DateObject(res.startDate),
        endDate: DateObject(res.endDate),
      };
    });
};

const getEditAppointmentTokenKey = (tokenId: string) => {
  return `edit-appointment-${tokenId}`;
};
